// extracted by mini-css-extract-plugin
export var collapsedSummary = "_no-0";